import React from 'react';

/**
 * Teardrop map pin SVG for the event placement preview marker.
 * Forest-green fill — matches the long-press burst and private-marker outline.
 * Reusable anywhere a map-pin visual is needed.
 */
export const PreviewPin: React.FC = () => (
  <svg width="28" height="38" viewBox="0 0 28 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 0C6.268 0 0 6.268 0 14C0 24.5 14 38 14 38C14 38 28 24.5 28 14C28 6.268 21.732 0 14 0Z"
      fill="var(--color-forest-bright)"
    />
  </svg>
);
